const locale = {
  dashboard: '首页'
};
export default locale;